import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const Notify = ({
  variant = "Dark",
  message,
  onClose,
  autoHide = true,
  show,
  position = "top-end",
}) => {
  return (
    <ToastContainer className="p-3" position={position}>
      <Toast
        className="d-inline-block m-1"
        bg={variant.toLowerCase()}
        autohide={autoHide}
        onClose={onClose}
        show={show}
        delay="2000"
      >
        <Toast.Header closeVariant={variant}>Alert</Toast.Header>
        <Toast.Body className={variant === "Dark" && "text-white"}>
          {message}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default Notify;
